import React, { Component } from 'react';
import config from 'react-global-configuration';

import { BrowserRouter, Redirect, Route, Link } from 'react-router-dom';

// Importação do Bootstrap
import { Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';

const PropTypes = require('prop-types');

class Topo extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      user: '',
      user_id: null,
      can_view_logbook_app_logs: false,
    };

    this.logout = this.logout.bind(this);
    this.loadCurrentUser = this.loadCurrentUser.bind(this);
    this.buildHeader = this.buildHeader.bind(this);
  }


  componentDidMount () {
    if (localStorage.getItem("data") !== null) {
      var data = JSON.parse(localStorage.getItem("data"));
      var user_id = parseInt(data.id, 10);
      this.setState({
        user: data.email,
        user_id: isNaN(user_id) ? null : user_id,
        can_view_logbook_app_logs: user_id === 10002,
      }, this.loadCurrentUser);
    } else {
      localStorage.removeItem("cid");
      this.context.router.history.push('/usuario/login');
    }
  }

  buildHeader() {
    var params = JSON.parse(localStorage.getItem("cid"));

    if(params === null || typeof params === 'undefined' || params.acode === null || typeof params.acode === 'undefined') {
      return null;
    }

    return {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + params.acode,
    };
  }

  loadCurrentUser() {
    var header = this.buildHeader();

    if(header === null) {
      localStorage.removeItem("cid");
      this.context.router.history.push('/usuario/login');
      return;
    }

    fetch(config.get('api_sigtrip') + '/usuario/home', { method: 'GET', mode: 'cors', headers: header }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      if(typeof responseJson === 'undefined' || responseJson === null) {
        return;
      }

      if(typeof responseJson.error !== 'undefined' || typeof responseJson.redirect_page !== 'undefined') {
        localStorage.removeItem("cid");
        this.context.router.history.push('/usuario/login');
        return;
      }

      if(responseJson.data && responseJson.data.id) {
        var data = JSON.parse(localStorage.getItem("data")) || {};
        data.email = responseJson.data.email || data.email;
        data.id = responseJson.data.id;
        localStorage.setItem("data", JSON.stringify(data));

        this.setState({
          user: data.email || '',
          user_id: responseJson.data.id,
          can_view_logbook_app_logs: parseInt(responseJson.data.id, 10) === 10002,
        });
      }
    });
  }

  logout(e) {
    e.preventDefault();
    localStorage.removeItem("cid");
    localStorage.removeItem("data");
    this.context.router.history.push('/usuario/login');
  }

  render() {
    return (
      <div>
        {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
        <section id="top">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-md-6" id="top-infs">
                Bem-vindo, {this.state.user} - <Link to={'/usuario/login'} onClick={this.logout}>Sair</Link>
              </div>
              <div className="col-xs-12 col-md-6 text-right" id="top-infs">
              </div>
            </div>
          </div>
        </section>
        <section id="header">
          <Navbar collapseOnSelect>
            <Navbar.Header>
              <Navbar.Brand>
                <Link to={'/'}><img src={config.get('cdn_sigtrip') + '/images/logo1.png'} style={{width: '100%'}} alt="SIGTREIN" /></Link>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav>
                <NavDropdown eventKey={1} title="Usuários" id="menu-cadastro">
                  <MenuItem href={'/usuarios'} className="menu-links">Lista de usuários</MenuItem>
                  <MenuItem href={'/usuario/cadastrar'} className="menu-links">Cadastrar usuário</MenuItem>
                </NavDropdown>
                <NavDropdown eventKey={2} title="SIGTRIP" id="menu-cadastro">
                  <MenuItem header>Permissões</MenuItem>
                  <MenuItem href={'/sigtrip/grupos/permissoes'} className="menu-links">Grupos de permissões</MenuItem>
                  <MenuItem href={'/sigtrip/grupo/permissao/cadastrar'} className="menu-links">Cadastrar grupo de permissão</MenuItem>
                  <MenuItem href={'/sigtrip/auditoria/permissoes'} className="menu-links">Auditoria de permissões</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Logs</MenuItem>
                  <MenuItem href={'/sigtrip/logs'} className="menu-links">Visualizar log</MenuItem>
                  <MenuItem href={'/sigtrip/log/erros'} className="menu-links">Log de erros</MenuItem>
                  <MenuItem href={'/sigtrip/log/voeomni'} className="menu-links">Logs do VoeOmni</MenuItem>
                  {this.state.can_view_logbook_app_logs ? <MenuItem href={'/sigtrip/log/logbookapp'} className="menu-links">Logs do Logbook App</MenuItem> : ''}
                  <MenuItem divider />
                  <MenuItem header>Usuários do sistema</MenuItem>
                  <MenuItem href={'/sigtrip/usuarios'} className="menu-links">Lista de usuários</MenuItem>
                  <MenuItem href={'/sigtrip/usuario/cadastrar'} className="menu-links">Cadastrar usuário</MenuItem>
                </NavDropdown>
                <NavDropdown eventKey={3} title="SIGMEC" id="menu-cadastro">
                  <MenuItem header>Permissões</MenuItem>
                  <MenuItem href={'/sigmec/grupos/permissoes'} className="menu-links">Grupos de permissões</MenuItem>
                  <MenuItem href={'/sigmec/grupo/permissao/cadastrar'} className="menu-links">Cadastrar grupo de permissão</MenuItem>
                  <MenuItem href={'/sigmec/auditoria/permissoes'} className="menu-links">Auditoria de permissões</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Logs</MenuItem>
                  <MenuItem href={'/sigmec/logs'} className="menu-links">Visualizar log</MenuItem>
                  <MenuItem href={'/sigmec/log/erros'} className="menu-links">Log de erros</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Usuários do sistema</MenuItem>
                  <MenuItem href={'/sigmec/usuarios'} className="menu-links">Lista de usuários</MenuItem>
                  <MenuItem href={'/sigmec/usuario/cadastrar'} className="menu-links">Cadastrar usuário</MenuItem>
                </NavDropdown>
                <NavDropdown eventKey={4} title="SIGTREIN" id="menu-cadastro">
                  <MenuItem header>Permissões</MenuItem>
                  <MenuItem href={'/sigtrein/grupos/permissoes'} className="menu-links">Grupos de permissões</MenuItem>
                  <MenuItem href={'/sigtrein/grupo/permissao/cadastrar'} className="menu-links">Cadastrar grupo de permissão</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Logs</MenuItem>
                  <MenuItem href={'/sigtrein/logs'} className="menu-links">Visualizar log</MenuItem>
                  <MenuItem href={'/sigtrein/log/erros'} className="menu-links">Log de erros</MenuItem>
                  <MenuItem divider />
                  <MenuItem header>Usuários do sistema</MenuItem>
                  <MenuItem href={'/sigtrein/usuarios'} className="menu-links">Lista de usuários</MenuItem>
                  <MenuItem href={'/sigtrein/usuario/cadastrar'} className="menu-links">Cadastrar usuário</MenuItem>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </section>
      </div>
    );
  }
}

Topo.contextTypes = {
  router: React.PropTypes.object.isRequired
}


export default Topo;



// WEBPACK FOOTER //
// ./src/Components/Layout/Topo.js